// assets/klaviyo-validate.js
console.log('✅ klaviyo-validate.js loaded');

;(function(){
  // Keep your original listener type
  const VALID_TYPES = ['submit'];

  // ---- Shared guards ----
  const LS_PREFIX = 'kvLead';             // per (formId,email) permanent de-dupe
  const SS_ONCE   = 'lead_event_fired';   // per-tab guard
  const SS_EID    = 'lead_event_id';      // shared event_id

  const norm = s => (s||'').trim().toLowerCase();
  const now = () => Date.now();

  const getLS = k => { try { return JSON.parse(localStorage.getItem(k)||'null'); } catch { return null; } };
  const setLS = (k,v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };
  const getSS = k => { try { return sessionStorage.getItem(k); } catch { return null; } };
  const setSS = (k,v) => { try { sessionStorage.setItem(k, v); } catch {} };
  const genEID = () => (crypto.randomUUID ? crypto.randomUUID()
                                          : String(Date.now())+':'+Math.random().toString(36).slice(2));

  function extractFormId({ formEl, eventDetail } = {}) {
    const ev = eventDetail || {};
    const fromEvent =
      ev.formId || ev.form_id || ev.id || ev.formVariant || ev.$form_id ||
      ev.form?.id || ev.form?.uuid;
    if (fromEvent) return String(fromEvent);

    const f = formEl;
    if (f) {
      const attrs = ['data-klaviyo-form-id','data-form-id','data-embed-uuid','data-testid','id','name','action'];
      for (const a of attrs) {
        if (a === 'action' && f.action) return 'action:'+f.action;
        const v = f.getAttribute && f.getAttribute(a);
        if (v) return String(v);
      }
    }
    return 'unknown-form';
  }

  function keyFor(formId, email){ return `${LS_PREFIX}:${formId}:${email}`; }

  // Permanent de-dupe per (formId,email) — no expiry
  function seenPermanently(formId, email){
    const k = keyFor(formId, email);
    const v = getLS(k);
    if (v && v.seen) return true;
    setLS(k, { seen: true, t: now() });
    return false;
  }

  function shouldFireOncePerTab(){
    return getSS(SS_ONCE) !== '1';
  }
  function markFiredOncePerTab(eid){
    setSS(SS_ONCE, '1');
    setSS(SS_EID, eid);
  }

  async function trackIfNew(email, formId){
    const em = norm(email);
    if (!em) return;

    // Per-tab guard stops double fire between native submit + klaviyoForms
    if (!shouldFireOncePerTab()) {
      console.log('[KlaviyoValidate] per-tab guard blocked duplicate');
      return;
    }

    // Permanent guard per (formId,email)
    if (seenPermanently(formId, em)) {
      console.log('[KlaviyoValidate] permanent dedupe for', formId, em);
      return;
    }

    // Generate/reuse one event_id per tab/session
    let eid = getSS(SS_EID);
    if (!eid) eid = genEID();

    // ---- HEAP (same logic you had) ----
    if (typeof heap !== 'undefined' && typeof heap.getIdentity === 'function') {
      heap.getIdentity(function(currentId) {
        console.log('[KlaviyoValidate] heap identity:', currentId, '→', em);
        if (!currentId) {
          heap.identify(em);
          heap.addUserProperties({ email: em });
          heap.track('Lead Conversion', { email: em, url: window.location.pathname, formId });
        } else {
          // already identified; still send Meta below
        }
      });
    }

    // ---- META (add event_id for dedupe w/ any CAPI or second path) ----
    if (typeof fbq === 'function') {
      fbq('track', 'Lead', { form_id: formId, event_id: eid });
      console.log('[KlaviyoValidate] Meta Lead fired', { formId, eid });
    } else {
      console.warn('[KlaviyoValidate] fbq not available');
    }

    markFiredOncePerTab(eid);
  }

  // 1) Bind native submit (your original behavior)
  function bindForms() {
    const forms = document.querySelectorAll('form.klaviyo-form');
    forms.forEach(form => {
      if (form.dataset.kvBound) return;
      form.dataset.kvBound = 'true';
      console.log('🔗 binding to klaviyo-form submit', form);
      form.addEventListener('submit', function(){
        const emailInput = form.querySelector('input[name="email"], input[type="email"]');
        const email = emailInput && emailInput.value;
        const formId = extractFormId({ formEl: form });
        trackIfNew(email, formId);
      });
    });
    return forms.length > 0;
  }

  if (!bindForms()) {
    let tries = 0;
    const iv = setInterval(() => { if (bindForms() || ++tries > 25) clearInterval(iv); }, 200);
  }

  // 2) Fallback: Klaviyo global event (same as you had)
  window.addEventListener('klaviyoForms', function(e) {
    if (!e.detail || !VALID_TYPES.includes(e.detail.type)) return;
    console.log('📣 got klaviyoForms event', e.detail);
    const email  = e.detail.metaData?.$email || e.detail.formData?.email;
    const formId = extractFormId({ eventDetail: e.detail });
    trackIfNew(email, formId);
  });
})();
